import { MaskitoOptions, maskitoTransform } from '@maskito/core'
import { maskitoNumberOptionsGenerator } from '@maskito/kit'
import { useMaskito } from '@maskito/react'
import { ComponentProps } from 'react'
import { Controller } from 'react-hook-form'
import { isNumber } from '~/shared/lib/utils'
import { IonInput } from '../styled'

type NumberParams = {
  min?: number
  max?: number
  precision?: number
  decimalSeparator?: string
  decimalPseudoSeparators?: string[]
  decimalZeroPadding?: boolean
  thousandSeparator?: string
  prefix?: string
  postfix?: string
  minusSign?: string
}

type NumericInputProps = {
  name: string
  numberParams?: NumberParams
  maskitoOptions?: MaskitoOptions
} & Omit<ComponentProps<typeof IonInput>, '$invalid'>

export function NumericInput({
  label,
  name,
  type,
  numberParams,
  children,
  errorText,
  maskitoOptions,
  ...inputProps
}: NumericInputProps) {
  const options: MaskitoOptions =
    maskitoOptions ??
    maskitoNumberOptionsGenerator({
      thousandSeparator: ' ',
      min: 0,
      ...numberParams,
    })
  const maskRef = useMaskito({ options })

  return (
    <Controller
      name={name}
      defaultValue=''
      render={({
        field: { onChange, value },
        fieldState: { error, invalid },
      }) => {
        return (
          <IonInput
            className={invalid || errorText ? 'ion-invalid ion-touched' : ''}
            ref={async (elInput) => {
              if (elInput) {
                const input = await elInput.getInputElement()
                maskRef(input)
              }
            }}
            onIonInput={(e) => {
              onChange(e.detail.value || '')
            }}
            value={maskitoTransform(
              isNumber(value) ? String(value) : value,
              options,
            )}
            name={name}
            label={label}
            type={type}
            errorText={error?.message || errorText || 'Обязательное поле'}
            {...inputProps}
            labelPlacement='floating'
            inputMode='numeric'
            fill='outline'
            mode='md'
          >
            {children}
          </IonInput>
        )
      }}
    />
  )
}
